import { ArrowUpRight } from "lucide-react";
import { JOURNAL_POSTS } from "../data/content";
import { useReveal } from "../hooks/useReveal";

const Blogs = () => {
    const ref = useReveal();
    return (
        <div ref={ref} data-testid="blogs-page" className="pt-24 md:pt-32">
            <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end reveal">
                    <div className="lg:col-span-8">
                        <p className="eyebrow mb-6">The Journal</p>
                        <h1
                            className="font-display text-samora-ink leading-[0.95] tracking-tight"
                            style={{ fontSize: "clamp(2.75rem, 7vw, 7rem)" }}
                        >
                            Slow writing<br />
                            <span className="italic font-serif text-samora-gold">
                                on considered homes.
                            </span>
                        </h1>
                    </div>
                    <p className="lg:col-span-4 text-samora-text/75 text-lg leading-relaxed">
                        Occasional notes from the studio — on material, light,
                        ritual, and the quiet decisions that make a house feel
                        like home.
                    </p>
                </div>
            </section>

            <section className="pb-24 md:pb-32">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
                        {JOURNAL_POSTS.map((p) => (
                            <article
                                key={p.id}
                                data-testid={`journal-post-${p.id}`}
                                className="group reveal"
                            >
                                <div className="img-hover-wrap h-[420px] md:h-[520px]">
                                    <img
                                        src={p.image}
                                        alt={p.title}
                                        loading="lazy"
                                    />
                                </div>
                                <div className="mt-6">
                                    <p className="text-xs tracking-widest uppercase text-samora-mute">
                                        {p.date} · {p.read}
                                    </p>
                                    <h3 className="mt-3 font-display text-2xl md:text-3xl text-samora-ink group-hover:text-samora-gold transition-colors flex items-start gap-2">
                                        {p.title}
                                        <ArrowUpRight
                                            size={20}
                                            strokeWidth={1.5}
                                            className="mt-1 flex-shrink-0"
                                        />
                                    </h3>
                                    <p className="mt-3 text-samora-text/70 text-sm leading-relaxed">
                                        {p.excerpt}
                                    </p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-24 md:py-32 bg-samora-sand/40">
                <div className="max-w-3xl mx-auto px-6 md:px-12 text-center reveal">
                    <p className="eyebrow mb-6">The Letter</p>
                    <h2
                        className="font-display text-samora-ink leading-[1.05] tracking-tight"
                        style={{ fontSize: "clamp(2rem, 4.5vw, 3.75rem)" }}
                    >
                        A slow, occasional<br />
                        <span className="italic font-serif text-samora-gold">
                            letter from the studio.
                        </span>
                    </h2>
                    <p className="mt-6 text-samora-text/75 leading-relaxed">
                        Once a quarter. Never noisy. Only when we have
                        something worth writing.
                    </p>
                    <form
                        onSubmit={(e) => e.preventDefault()}
                        className="mt-10 flex flex-col md:flex-row gap-4 max-w-lg mx-auto"
                    >
                        <input
                            data-testid="newsletter-email"
                            type="email"
                            placeholder="you@example.com"
                            className="samora-input flex-1 text-center md:text-left"
                        />
                        <button
                            data-testid="newsletter-submit"
                            className="btn-samora"
                        >
                            Subscribe
                        </button>
                    </form>
                </div>
            </section>
        </div>
    );
};

export default Blogs;
